import { gql } from '@apollo/client/core';

/**
 * Selections for the whitelabel screens. Keep this in step with `WhitelabelConfig.ts` — every field
 * selected here is mapped there, and nothing more is selected than is mapped.
 *
 * One fragment rather than the list/detail pair `Internal/Account` needs: the index, the edit form
 * and the save payload all show the same record, so a split would buy nothing and would let a list
 * row silently blank a loaded config.
 */
export const INTERNAL_WHITELABEL_CONFIG_FIELDS = gql`
  fragment InternalWhitelabelConfigFields on WhitelabelConfig {
    id
    domain
    name
    landingUrl
    fromEmail
    stripeApiKey
    stripePublishableKey
    checkoutUrlBase
    attribution
    attachment {
      id
      name
      mime
      size
      checksum
      status
      url
    }
  }
`;

// These two are shared by the status read and the re-check mutation, which map through the same mappers.
export const INTERNAL_WHITELABEL_CLOUDFLARE_HOSTNAME_FIELDS = gql`
  fragment InternalWhitelabelCloudflareHostnameFields on WhitelabelCloudflareHostnameStatus {
    role
    host
    checked
    error
    hostnameRegistered
    hostnameStatus
    certificateStatus
    customOriginServer
    transformRuleCovered
    coverageError
  }
`;

export const INTERNAL_WHITELABEL_DNS_RECORD_CHECK_FIELDS = gql`
  fragment InternalWhitelabelDnsRecordCheckFields on WhitelabelDnsRecordCheck {
    role
    name
    type
    purpose
    expectedTarget
    outcome
    actual
    error
  }
`;

export const INTERNAL_WHITELABEL_ONBOARDING_STATUS_FIELDS = gql`
  fragment InternalWhitelabelOnboardingStatusFields on WhitelabelOnboardingStatus {
    configId
    domain
    state
    checkedAt
    accounts {
      accountId
      name
    }
    cloudflareHostnames {
      ...InternalWhitelabelCloudflareHostnameFields
    }
    dnsRecords {
      ...InternalWhitelabelDnsRecordCheckFields
    }
  }
  ${INTERNAL_WHITELABEL_CLOUDFLARE_HOSTNAME_FIELDS}
  ${INTERNAL_WHITELABEL_DNS_RECORD_CHECK_FIELDS}
`;
